export default __webpack_public_path__ + "static/media/trash-can-red.384d86e1.svg";